module.exports = __webpack_public_path__ + "img/marker-red.3b98c7c9.svg";